export const MEASURE_GUIDE_MOCK = {
	title: '<h2 class="carousel-title">How to Measure Blind Opening</h2>',
	description: '<p class="slide-text">These measurements help us provide a more accurate quote.</p>',
	slides: [
		`
			<h3 class="slide-title">
			<span class="slide-number">1</span>
			<span>Measure the opening width</span>
			</h3>
			<p class="slide-text">Measure the opening width in three places (top, middle and bottom). The smallest measurement is your opening width.</p>
			<img src="assets/images/measure-blind/measure-slide-1.png" alt="Measure the opening width"/>
		`,

		`
			<h3 class="slide-title">
			<span class="slide-number">2</span>
			<span>Measure the opening height</span>
			</h3>
			<p class="slide-text">Measure the opening height on both the left and right sides. Use the smallest height.</p>

			<img src="assets/images/measure-blind/measure-slide-2.png" alt="Measure the opening height"/>
		`,

		`
			<h3 class="slide-title">
			<span class="slide-number">3</span>
			<span>Enter your measurements</span>
			</h3>
			<p class="slide-text">Enter all measurements in millimetres (mm). Do not round up or down.<br />An installer will verify all measurements before manufacturing.</p>
		`,
	],
};
